import React, { useContext } from 'react'

import Typography from '@mui/material/Typography'
import { Column, Icon, Row } from '@vividseats/vivid-ui-kit'
import { useRouter } from 'next/router'

import productionsDetailsContext from '@/context/production-details'
import { trackEvent } from '@/utils/analytics/ga360'

import dateSwitcherContext from './context'
import styles from './styles.module.scss'

const DateSwitcher: React.FC = () => {
    const router = useRouter()
    const { slug, id } = router.query as { slug?: string; id: string }

    const {
        selectors: { dateSwitcherInfo },
    } = useContext(productionsDetailsContext)

    const {
        dispatch: { setSelectedProduction, toggleSheet },
    } = useContext(dateSwitcherContext)

    return dateSwitcherInfo && dateSwitcherInfo.productionsCount > 1 ? (
        <Column pt={1} noFlex>
            <Row
                align="center"
                className={styles.dateSwitcher}
                onClick={() => {
                    const webPath = slug ? `/${slug}/production/${id}` : `/production/${id}`
                    setSelectedProduction({ id: Number(id), webPath })
                    toggleSheet(true)
                    trackEvent('Date Picker', 'OpenDatePicker', 'clicked', undefined, false)
                }}
                data-testid="date-switcher"
            >
                <div className={styles.label}>
                    <Typography variant="small-medium" color="gray.600">
                        <Icon className={styles.icon} size="sm" type="calendar-multi" />
                        {dateSwitcherInfo.label}
                    </Typography>
                </div>
                <Typography variant="caption-regular" color="gray.400">
                    {dateSwitcherInfo.caption}
                </Typography>
            </Row>
        </Column>
    ) : null
}

export default DateSwitcher
